import React from "react";
import cx from "classnames";
import { Link } from "../link";

import * as styles from "./menu-item.module.css";

export const MenuItem = ({
  className,
  activeClassName = "active",
  style,
  item,
  ariaLabel,
  clickHandler,
  onMouseEnter,
  onMouseLeave,
  onMouseOver,
  children,
  activeSubmenu,
}) => {
  switch (item.type) {
    case "internalLink":
    case "externalLink":
      return (
        <li className={cx(styles.menuItem, className)} style={style}>
          <Link
            type={item.type}
            activeClassName={activeClassName}
            onClick={(event) => clickHandler && clickHandler(event, item)}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onMouseOver={onMouseOver}
            link={item && item}
            aria-label={ariaLabel}
          >
            {children}
          </Link>
        </li>
      );
    case "submenu":
      return (
        <li className={cx(styles.menuItem, className)}>
          <button
            className={
              activeSubmenu &&
              item.submenu &&
              activeSubmenu.id === item.submenu.id
                ? "active-button"
                : ""
            }
            onClick={(event) => clickHandler && clickHandler(event, item)}
          >
            {children}
          </button>
        </li>
      );

    default:
      return <span>Yo</span>;
  }
};
